// Components
import DatePicker from 'vue2-datepicker';
const FileUpload = () => import(/* webpackPrefetch: true, webpackChunkName: "file-upload" */ '@/app/views/main-view/_shared/_components/file-upload/file-upload.vue');
const ModalFindReplaceWithPetName = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-find-replace-with-pet-name"*/ '@/app/views/main-view/notifications/containers/modals/modal-find-replace-with-pet-name/modal-find-replace-with-pet-name.vue');

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util';

// Mixins
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { imageUploadMixins } from '@/app/mixins/utils/image-upload-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

// Services
import BreedService from '@/app/services/main/breeds/breeds-service';
import NotificationService from '@/app/services/main/notifications/notifications-service';
import userService from '@/app/services/main/user/user-service.js';
import ProductService from "@/app/services/main/product/product-service";
import BundleService from "@/app/services/main/bundles/bundles-service";
import breederService from "@/app/services/main/breeder/breeder-service.js";

// Constants
import { STATUS_CODES, LIST } from '@/app/constants/constants';

const {
	SIZEGROUPLIST,
	RECIPIENTLIST,
	RECIPIENTLISTAGE,
	YEARLIST,
	MONTHLIST,
	MONTHLISTWITHZERO
} = LIST;

export default {
	name: 'NotificationSendComponent',
	components: {
		DatePicker,
		FileUpload,
		ModalFindReplaceWithPetName
	},
	mixins: [
		dateMixins,
		imageUploadMixins,
		toastMessageMixins,
		inputTextMixins
	],
	data() {
		return {
			selectedRecipientAll: false,
			isAPILoading: false,
			isBreedAPILoading: false,
			// notification
			notificationTitle: '',
			notificationBody: '',
			notificationLink: '',
			notificationSchedule: '',
			selectedRecipient: [],
			selectedAgeGroup: 'ALL',
			notificationType:'DATE',
			selectedOption: '',
			selectedYear: '0',
			selectedMonth: '0',
			isZero: false,
			sizeGroupList: SIZEGROUPLIST,
			recipientList: RECIPIENTLIST,
			recipientListAGE: RECIPIENTLISTAGE,
			yearList: YEARLIST,
			monthList: MONTHLISTWITHZERO,
			breedList: [],
			observer: null,
			customerOptions: [],
			customerLoading: false,
			breederOptions: [],
			breederLoading: false,
			page: 1,
			pageCount: 2,
			photoUrl:"",
			isFromTreatment:false
		}
	},
	computed: {
		validationRules() {
			let fields = {
				notificationTitle: {},
				notificationBody: {},
				selectedRecipient: {},
				selectedOption: {}
			}

			if(this.notificationType === 'DATE') {
				fields.notificationSchedule = {};
			} else {
				fields.selectedYear = {};
				fields.selectedMonth = {};
			}

			fields = vuelidateUtil.setFieldsRequired(fields, true);

			return fields;
		},
		hasUploaded() {
			let img = '';
			if (this.imageUrl) {
				img = this.imageUrl;
			} else if (this.photoUrl) {
				img = this.photoUrl;
			} else {
				img = require('@/assets/images/_shared/notification-dog.png')
			}

			return img;
		},
		isInvalid() {
			return this.$v.$invalid;
		},
		hasNextPage() {
			return this.page < this.pageCount;
		}
	},
	watch: {
		selectedRecipientAll(newOption) {
			if (newOption) {
				this.selectedRecipient = [];
				this.selectedRecipient.push('all');
				this.$v.selectedRecipient.$reset()
			} else {
				this.selectedRecipient = [];
				this.$v.selectedRecipient.$reset()
			}
		},
		selectedOption(newOption) {
			this.selectedRecipient = []
			this.selectedRecipientAll = false
			if (newOption === 'ALL') {
				this.selectedRecipient = 'all';
			} else {
				if (newOption === 'CUSTOMER') {
					this.observer = new IntersectionObserver(this.infiniteScroll);

					this.customerLoading = true;
					this.callCustomersAPI()
						.then(() => {
							this.customerLoading = false;
						});
				}

				if (newOption === 'BREEDER') {
					this.observer = new IntersectionObserver(this.infiniteScrollBreeders);

					this.customerLoading = true;
					this.callBreedersAPI()
						.then(() => {
							this.breederLoading = false;
						});
				}
				// Clear recipient every time option changes.
				this.selectedRecipient = [];
				this.selectedAgeGroup = 'ALL'
				
				if(this.$route.query.id){
					this.selectedRecipient = [this.$route.query];
				} else if (this.$route.query.fromBreeds) {
					const breeds = this.$store.getters.getSelectedBreeds;

					for (const i of breeds) {
						this.selectedRecipient.push(i.id);
					}
				}
			}

			this.$v.selectedRecipient.$reset();
		},
		selectedYear(newOption) {
			if(newOption === "0"){
				this.monthList = MONTHLIST;
			}else{
				this.monthList = MONTHLISTWITHZERO;
			}
		},
		notificationType(newVal) {
			if(newVal === 'DATE'){
				this.selectedYear = '';
				this.selectedMonth = '';
				this.notificationSchedule= this.dateToISO(new Date());
			}else{
				this.selectedYear = '0';
				this.selectedMonth = '0';
				this.notificationSchedule = '';
				this.isZero = false;
			}
			this.selectedRecipient = [];
			this.selectedOption = '';
			
			// validation
			this.$v.$reset();
		}
	},
	created() {
		this.getBreedList();
		if (this.$route.query.id) {			
			this.selectedOption = "CUSTOMER";
		} else if (this.$route.query.fromBreeds) {
			this.selectedOption = "BREEDS";
		} else if (this.$route.query.productId){
			this.selectedOption = "BREEDS";
			this.initialLoadProduct();
		} else if (this.$route.query.bundleId) {
			this.selectedOption = "BREEDS";
			this.initialLoadBundle();
		}

		this.isFromTreatment = this.$route.query.actionFrom === 'treatment'

		// Copy notification
		this.getNotificationCopy();
	},
	methods: {
		async initialLoadProduct() {
			await this.getProducts();
		},
		getProducts() {
			if (this.$route.params && this.$route.query.productId) {
			  ProductService.getProductById(this.$route.query.productId).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
				const {
					age,
					name,
					imageUrl,
					breeds,
					bundleId
				} = res.data;

				
					this.photoUrl = imageUrl;
					this.notificationTitle = name;
					this.notificationLink = `${process.env.VUE_APP_SITE_URL}/products/details?sku=${bundleId}`;
					this.selectedAgeGroup = age;
					
					const breedsSelected = breeds;

					for (const i of breedsSelected) {
						if (i.status === 'A') {
							if( i.breedId !== 0 ){
								this.selectedRecipient.push(i.breedId);
							}
							
						}
						
					}

				} else {
				  this.showAPIErrorToast(
					this.toastMessages.product().ERROR_PRODUCT_FETCH,
					res
				  );
				}
	  
				this.isEditAPILoading = false;
			  });
			}
		},
		async initialLoadBundle() {
			await this.getBundles();
		},
		getBundles() {
			if (this.$route.params && this.$route.query.bundleId) {
				BundleService.getBundleById(this.$route.query.bundleId).then((res) => {
				  if (res.status === STATUS_CODES.SUCCESS) {
					const {
						name: bundleName,
						age,
						imageUrl,
						id,
						breeds
					} = res.data;
  
				  
					  this.photoUrl = imageUrl;
					  this.notificationTitle = bundleName;
					  this.notificationLink = `${process.env.VUE_APP_SITE_URL}/products/details?sku=${id}`;
					  this.selectedAgeGroup = age;
					  
					  const breedsSelected = breeds;
  
					  for (const i of breedsSelected) {
						  if (i.status === 'A') {
								if (i.breedId !== 0) {
									this.selectedRecipient.push(i.breedId);
								} 
						  } 
					  }
  
				  } else {
					this.showAPIErrorToast(
					  this.toastMessages.product().ERROR_PRODUCT_FETCH,
					  res
					);
				  }
		
				  this.isEditAPILoading = false;
				});
			  }
		},
		insertName(){
			this.notificationBody = this.notificationBody === '' ? this.notificationBody + "PET_NAME" : this.notificationBody + " PET_NAME ";
		},
		onBlur(option) {
			if (option === 'selectedOption') {
				this.$v.selectedOption.$touch();
			} else if (option === 'selectedRecipient') {
				this.$v.selectedRecipient.$touch();
			} else if (option === 'selectedYear') {
				this.$v.selectedYear.$touch();
				this.checkZero();
			} else if (option === 'selectedMonth') {
				this.$v.selectedMonth.$touch();
				this.checkZero();
			}
		},
		checkZero() {
			if(this.selectedMonth === "0" && this.selectedYear === "0"){
				this.isZero = true;
			}else{
				this.isZero = false;
			}
		},
		getBreedList() {
			this.isBreedAPILoading = true;
			BreedService.getBreeds()
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.breedList = res.data.data.filter((breed) => {
							if (breed.id !== 0) {
								return {
									...breed
								};
							}
						});
						
					} else {
						this.showAPIErrorToast('Unable to get Breeds', res);
					}

					this.isBreedAPILoading = false;
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isBreedAPILoading = false;
				});
		},
		onSubmit(isMore) {
			if (this.isInvalid) {
				return;
			}

			let customers = null;
			if (this.selectedOption === 'CUSTOMER' || 
				this.selectedOption === 'BREEDER') {
				customers = this.selectedRecipient.map( recipient => {
					return recipient.id;
				});
			}
			
			this.isAPILoading = true;
			const formDetails = {
				title: this.notificationTitle,
				body: this.notificationBody,
				baseDate: this.notificationType === "AGE" ? this.notificationSchedule : this.dateToISO(this.notificationSchedule),
				recipientGroup: this.selectedOption,
				recipients: customers ? customers : Array.isArray(this.selectedRecipient) ? this.selectedRecipient : 
					this.selectedRecipient.length > 0 ? [this.selectedRecipient] : [],
				age: this.selectedAgeGroup,
				// ageBase
				ageBase: this.notificationType === "AGE",
				ageInMonths: ( parseInt(this.selectedYear) * 12 ) + parseInt(this.selectedMonth),
				photoUrl: this.photoUrl
			}

			if (this.notificationLink !== '') {
				formDetails.link = this.notificationLink;
			}

			const notificationDetails = {
				formDetails,
				notificationImage: this.fileBlob ? this.fileBlob[0] : ''
			};

			NotificationService.postNotification(notificationDetails)
				.then(res => {
					const {SUCCESS_NOTIFICATION_SEND, ERROR_NOTIFICATION_SEND} = this.toastMessages.notification();
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.resetFields();
						this.showCustomSuccessToast(SUCCESS_NOTIFICATION_SEND);

						if (this.$route.query.fromBreeds) {
							this.$store.commit('clearSelectedBreeds');
						}

						if (!isMore) {
							this.$router.push('/notifications');
						} else {
							if (this.$route.query.fromBreeds) {
								this.$router.replace('/notifications/send');
							}
						}
					} else {
						this.showAPIErrorToast(ERROR_NOTIFICATION_SEND, res);
					}

					this.isAPILoading = false;
				});
		},
		notPastDate(date) {
			return date < new Date().setHours(0,0,0,0);
		},
		resetFields() {
			this.notificationTitle = '';
			this.notificationBody = '';
			this.notificationLink = '';
			this.notificationSchedule = '';
			this.selectedRecipient = [];
			this.selectedOption = '';

			if(this.notificationType==='AGE'){
				this.selectedYear = '';
				this.selectedMonth = '';
				this.notificationSchedule= this.dateToISO(new Date());
			}else{
				this.selectedYear = '0';
				this.selectedMonth = '0';
				this.notificationSchedule = '';
				this.isZero = false;
			}
			// reset image
			this.resetImageFields();

			// validation
			this.$v.$reset();
		},
		async onOpen() {
			// Observe the list-footer
			if (this.hasNextPage) {
				// we need to wait for the nextTick for it to see our refs.
				await this.$nextTick();
				this.observer.observe(this.$refs.load);
			}
		},
		onClose() {
			this.observer.disconnect();
		},
		getBreeders(searchQuery = '') {
			this.query = searchQuery;
			this.delayTyping(async () => {
				// reset page to 1 when querying.
				this.page = 1;
				await this.callBreedersAPI(this.query);
			});
		},
		getCustomers(searchQuery = '') {
			this.query = searchQuery;
			this.delayTyping(async () => {
				// reset page to 1 when querying.
				this.page = 1;
				await this.callCustomersAPI(this.query);
			});
		},
		async infiniteScroll([{isIntersecting, target}]) {
			if (isIntersecting) {
				// save the current scroll position before calling API
				const ul = target.offsetParent;
				const scrollTop = target.offsetParent.scrollTop;
				this.page += 1;
				await this.callCustomersAPI(this.query);
				// wait for our list to update before setting the previous scroll position.
				await this.$nextTick();
				ul.scrollTop = scrollTop;
			}
		},

		async infiniteScrollBreeders([{isIntersecting, target}]) {
			if (isIntersecting) {
				// save the current scroll position before calling API
				const ul = target.offsetParent;
				const scrollTop = target.offsetParent.scrollTop;
				this.page += 1;
				await this.callBreedersAPI(this.query);
				// wait for our list to update before setting the previous scroll position.
				await this.$nextTick();
				ul.scrollTop = scrollTop;
			}
		},

		callBreedersAPI(query = '') {

			const queryParams = {
				limit: 10,
				page: this.page,
				'f_status': 'ACTIVE',
				'f_name': query,
				desc: true
			};

			return breederService.getBreedersSuggestionList(queryParams)
				.then( async res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const processedData = res.data.data.map(breeder => {
							return {
								id: breeder.userId,
								name: breeder.email,
								fullName: breeder.name
							}
						});

						if (this.page !== 1) {
							this.breederOptions = [...this.breederOptions, ...processedData];
						} else {
							this.breederOptions = processedData;
						}

						this.pageCount = res.data.pagination.pageCount;
					} else {
						this.showAPIErrorToast(this.toastMessages.product().ERROR_PRODUCT_FETCH, res);
					}
				});
		},
		callCustomersAPI(query = '') {

			const queryParams = {
				limit: 10,
				page: this.page,
				'f_status': 'ACTIVE',
				'f_role': 'CUST',
				'f_name': query,
				desc: true
			};

			return userService.getCustomer(queryParams)
				.then( async res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const processedData = res.data.data.map(customer => {
							return {
								id: customer.id,
								name: customer.emailAddress,
								fullName: customer.firstName +" "+ customer.lastName
							}
						});

						if (this.page !== 1) {
							this.customerOptions = [...this.customerOptions, ...processedData];
						} else {
							this.customerOptions = processedData;
						}

						this.pageCount = res.data.pagination.pageCount;
					} else {
						this.showAPIErrorToast(this.toastMessages.product().ERROR_PRODUCT_FETCH, res);
					}
				});
		},
		showModalFindReplaceWithPetName() {
			this.$refs.modalFindReplaceWithPetName.show(this.notificationBody);
		},
		replaceBodyWithPetName(newBody) {
			this.notificationBody = newBody;
		},
		getNotificationCopy() {
			if (this.$route.name === 'Copy Notification' && this.$route.params.id) {
				NotificationService.getNotificationById(this.$route.params.id)
					.then(res => {
						if (res.status === STATUS_CODES.SUCCESS) {
							this.formatModelToCopy(res.data);
						} else {
							this.showAPIErrorToast('Unable to copy notification.', res);
						}
					});
			}
		},
		formatModelToCopy(res) {
			const year = parseInt(res.ageInMonths / 12);
			const month = res.ageInMonths % 12;
			this.notificationTitle = res.title;
			this.notificationBody = res.body;
			this.notificationLink = res.link ? res.link: '';
			const type = res.scheduleType ? res.scheduleType.split('_') : [];
			this.notificationType = type[0];
			this.notificationSchedule = res.scheduleNotification ? new Date(res.scheduleNotification) : '';
			let recipients = [];
			switch (res.recipientGroup) {
				case 'BREEDS':
				case 'BREED_SIZE':
					for (const recipient of res.recipients) {
						recipients.push(recipient.id);
					}
					break;
				case 'PET_AGE':
					recipients = '';
					if (res.recipients.length > 0) {
						recipients = res.recipients[0].id;
					}
					break;
				default:
					if (res.recipients.length === 1 &&
						res.recipients[0].id === null
					) {
						recipients = ['ALL']
					} else {
						recipients = res.recipients;
					}
					break;
			}

			// Set timeout to wait for the UI changes.
			setTimeout(() => {
				this.selectedOption = res.recipientGroup;
				this.selectedYear = year;
				this.selectedMonth = month;
			}, 200);

			setTimeout(() => {
				this.selectedRecipientAll = recipients.includes('ALL')
				this.selectedRecipient = recipients;
			}, 500);
		}
	},
	validations() {
		return this.validationRules;
	}
	// third party libraries
}